import ApiClient from "@/api/ApiClient.ts";

const state = {};

const mutations = {};

const actions = {
  async getReportDistanceEurotaxi(_, customParams) {
    const params = {
      output: "xlsx",
      ...customParams,
    };
    try {
      let { data } = await ApiClient().get("reports/distanceEurotaxi", {
        params,
        responseType: "blob",
      });
      return data;
    } catch (error) {
      console.error("ERROR en getReportDistanceEurotaxi: ", error.response);
      return false;
    }
  },

  async getCallsPickedPerTurn(_, params) {
    try {
      let { data } = await ApiClient().get("reports/callsPickedByTurn", {
        params,
      });
      return data;
    } catch (error) {
      console.error("ERROR en getCallsPickedPerTurn: ", error.response);
      return false;
    }
  },

  // action, zoneId and taxiId are optional
  async getEnterExitZones(_, { wgId, from, to, action, zoneId, taxiId }) {
    try {
      let { data } = await ApiClient({ timeout: 20 * 60 * 1000 }).get("reports/enterExitZones2", {
        params: {
          wgId,
          from,
          to,
          action,
          zoneId,
          taxiId,
        },
      });
      return data;
    } catch (error) {
      console.error("ERROR en getEnterExitZones: ", error.response);
      return false;
    }
  },

  async getReportOperatorsServices(_, params) {
    try {
      let { data } = await ApiClient().get("reports/operatorsServices", {
        params,
        responseType: "blob",
      });
      return data;
    } catch (error) {
      console.error("ERROR en getReportOperatorsServices: ", error.response);
      return false;
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
